import { c as _c } from "react/compiler-runtime";
import { cx } from '@/src/styles/stylebook';
import Link from 'next/link';
import ImageBox from '../ImageBox';
import Multilingual from '../global/Multilingual';
const ProgramItem = t0 => {
  const $ = _c(39);
  const {
    program,
    className
  } = t0;
  if (!program || !program.thumbnail || !program.slug || !program.title_kr || !program.title || !program.director) {
    return null;
  }
  const t1 = program._id;
  let t2;
  if ($[0] !== className) {
    t2 = cx("pb-20", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `/films/${program.slug}`;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = cx("flex flex-col gap-2 no-underline max-md:gap-1.5");
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== program.thumbnail) {
    t5 = <div className="border-gray-0 aspect-video overflow-hidden rounded-2xl border-3 max-md:rounded-xl max-md:border-2"><ImageBox image={program.thumbnail} classesWrapper="w-full h-full block" /></div>;
    $[3] = program.thumbnail;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== program.section) {
    t6 = program.section?.map(_temp);
    $[5] = program.section;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t6) {
    t7 = <span className="smallp max-lg:caption mt-0.5 mb-1.5 text-green-50 max-lg:mb-1">{t6}</span>;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== program.title_kr) {
    t8 = <span className="bold max-lg:smallp -mt-0.5 mb-1 max-lg:mb-0"><Multilingual>{program.title_kr}</Multilingual></span>;
    $[9] = program.title_kr;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t9 = program.year;
  const t10 = program.genre;
  const t11 = program.color === "colorBw" ? "Color+B&W" : program.color === "bw" ? "B&W" : "Color";
  const t12 = (program.runtime || program.subtitles) && `${program.runtime.minutes}min${" "}${program.runtime.seconds !== 0 ? `${program.runtime.seconds}sec` : ""}
                  ${program?.subtitles ? `(${program?.subtitles?.map(_temp2).filter(Boolean).join(", ")})` : ""}
                  `;
  const t13 = program.premiere !== "none" && program.premiere ? program.premiere : "";
  let t14;
  if ($[11] !== program.rating) {
    t14 = program.rating.toUpperCase();
    $[11] = program.rating;
    $[12] = t14;
  } else {
    t14 = $[12];
  }
  let t15;
  if ($[13] !== program.genre || $[14] !== program.year || $[15] !== t11 || $[16] !== t12 || $[17] !== t13 || $[18] !== t14) {
    t15 = [t9, t10, t11,, t12, t13, t14].filter(Boolean);
    $[13] = program.genre;
    $[14] = program.year;
    $[15] = t11;
    $[16] = t12;
    $[17] = t13;
    $[18] = t14;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  const t16 = t15.join(" | ");
  let t17;
  if ($[20] !== t16) {
    t17 = <span className="max-lg:smallp capitalize *:break-all"><Multilingual>{t16}</Multilingual></span>;
    $[20] = t16;
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  let t18;
  if ($[22] !== program.director) {
    t18 = program.director?.map(_temp3);
    $[22] = program.director;
    $[23] = t18;
  } else {
    t18 = $[23];
  }
  let t19;
  if ($[24] !== t18) {
    t19 = <span className="max-lg:smallp">{t18}</span>;
    $[24] = t18;
    $[25] = t19;
  } else {
    t19 = $[25];
  }
  let t20;
  if ($[26] !== t17 || $[27] !== t19 || $[28] !== t7 || $[29] !== t8) {
    t20 = <div className="bold flex flex-col leading-snug break-words">{t7}{t8}{t17}{t19}</div>;
    $[26] = t17;
    $[27] = t19;
    $[28] = t7;
    $[29] = t8;
    $[30] = t20;
  } else {
    t20 = $[30];
  }
  let t21;
  if ($[31] !== t20 || $[32] !== t3 || $[33] !== t5) {
    t21 = <Link href={t3} className={t4}>{t5}{t20}</Link>;
    $[31] = t20;
    $[32] = t3;
    $[33] = t5;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  let t22;
  if ($[35] !== program._id || $[36] !== t2 || $[37] !== t21) {
    t22 = <div key={t1} className={t2}>{t21}</div>;
    $[35] = program._id;
    $[36] = t2;
    $[37] = t21;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  return t22;
};
export default ProgramItem;
function _temp(s) {
  return <span key={s._id} className="after:mr-1 after:content-[','] last:after:content-['']"><Multilingual>{s.title}</Multilingual></span>;
}
function _temp2(s_0) {
  return s_0?.toUpperCase?.();
}
function _temp3(d) {
  return <span key={d._id} className="after:text-gray-0 after:mr-1 after:content-[','] last:after:content-['']"><span className="mr-1"><Multilingual>{d.title_kr}</Multilingual></span><span className=""><Multilingual>{d.title}</Multilingual></span></span>;
}